import type { HTMLAttributes } from "react";

export function Card({ className = "", ...rest }: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div className={`bg-tape border border-border shadow-sleeve p-5 ${className}`} {...rest} />
  );
}
